import { render, staticRenderFns } from "./MemberInvite.vue?vue&type=template&id=f2af9824&scoped=true"
import script from "./MemberInvite.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberInvite.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MemberInvite.vue?vue&type=style&index=0&id=f2af9824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af9824",
  null
  
)

export default component.exports